<template>
  <div class="pack__base">
    <div class="pack__splash_screen">
      <div class="pack__information">
        <p class="pack__title font-bold">{{ pack.title }}</p>
        <p class="text-white mt-4">
          <span class="font-bold">Publié par</span> {{ pack.author }}
          <span class="font-bold">{{ duration(pack.created_at) }}</span>
        </p>
        <vs-button
          @click="
            $router.push({
              path: '/formation/packs/' + pack.slug + '/follow-pack',
            })
          "
          size="small"
          :color="$store.state.aa_button_color"
          type="filled"
          class="mt-4 text-dark action_button"
          >Suivre</vs-button
        >
      </div>
    </div>
    <div class="pack__trainings mlx-24 mrx-24 mb-4 mt-4">
      <h4 class="font-bold">Formations</h4>
      <div class="vx-row mt-2 ml-1">
        <div class="w-1/3">
          <p class="fields_label font-bold text-black">Catégories</p>
          <v-select
            class="w-full"
            label="name"
            v-model="selectedCategoryId"
            :reduce="(category) => category.id"
            :options="categories"
          ></v-select>
        </div>
        <div class="w-1/4 ml-2">
          <p class="fields_label font-bold text-black">Rechercher</p>
          <vs-input
            @keypress.enter="searchInfo()"
            autocomplete="off"
            name="search"
            class="w-full"
            v-model="search"
          />
        </div>
      </div>
      <div class="mt-6 pb-4">
        <div class="trainings">
          <div
            class="training"
            v-for="(item, key) in pack.trainings"
            :key="key"
          >
            <ul>
              <li class="card">
                <div
                  class="training_illustration"
                  :style="illustration(item.illustration_file)"
                ></div>
                <div class="vx-row mt-2 ml-1">
                  <div class="w-3/4">
                    <h5>{{ item.title | truncate(30) }}</h5>
                  </div>
                  <div class="w-1/4">
                    <vs-chip v-if="item.is_new == 1" color="danger">
                      Nouveau
                    </vs-chip>
                  </div>
                </div>

                <!-- <p>Lorem ipsum sit dolor amit</p> -->
                <vs-button
                  @click="
                    $router.push({
                      path:
                        '/formation/packs/' +
                        pack.slug +
                        '/follow-pack/' +
                        item.slug,
                    })
                  "
                  size="small"
                  :color="$store.state.aa_button_color"
                  class="action_button text-dark mt-6"
                  >Suivre</vs-button
                >
              </li>
              <!-- additional cards -->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _buildQuery } from "../../../../helpers/buildquery";
import moment from "moment";

export default {
  name: "detailsPack",
  components: {},
  data() {
    return {
      pack: {
        title: "",
        created_at: "",
        author_name: "",
        trainings: [],
      },
      cssProps: {
        background: "",
      },
      selectedCategoryId: "",
      categories: [],
      search: "",
      trainingCssProps: {
        backgroundImage: "",
      },
      default_trainings: [],
    };
  },
  watch: {
    selectedCategoryId(Value) {
      this.default_trainings = [...this.pack.trainings];
      if (Value) {
        this.pack.trainings = this.pack.trainings.filter(function (training) {
          return training.category_training_id == Value;
        });
      } else this.getPackInformation();
    },
    search(value) {
      this.default_trainings = [...this.pack.trainings];
      if (value) {
        this.pack.trainings = this.pack.trainings.filter(function (training) {
          // return training.title == value;
          return (
            training.title.toLowerCase().indexOf(value.toLowerCase()) !== -1
          );
        });
      } else this.getPackInformation();
    },
  },
  methods: {
    duration(created_at) {
      const value = moment(created_at);
      value.locale("fr");
      return value.fromNow();
    },
    async getPackInformation() {
      this.$vs.loading();
      let payload = {
        category: this.selectedCategoryId,
      };
      try {
        let response = await this.$http.get(
          "trainings-pack/information/" +
            this.$route.params.slug +
            _buildQuery(payload)
        );
        if (response.data) {
          this.pack = response.data;
          this.$vs.loading.close();
        }
      } catch (error) {
        this.$vs.notify({
          title: "Erreur",
          text: "Veuillez contacter l'administrateur",
          color: "danger",
          position: "top-right",
        });
        this.$vs.loading.close();
      }
    },
    async getCategoriesTraining() {
      try {
        // this.$vs.loading();
        let response = await this.$http.get("/categories/trainings");
        if (response.data) {
          this.categories = response.data;
          this.$vs.loading.close();
        }
      } catch (error) {
        if (error.response.data.status === 401) {
          this.$vs.notify({
            title: "Erreur",
            text: "Votre session a expiré",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
          this.$router.push("/login");
        }
      }
    },

    searchInfo() {},
    illustration(illustration_full_path = null) {
      let trainingCssProps = {
        "background-image": "",
      };
      const illustration = require("@/assets/images/pages/momo_agents-min.jpg");
      if (illustration_full_path) {
        trainingCssProps["background-image"] =
          `linear-gradient(180deg, rgba(255, 255, 255, 0) 61.46%, #FFFFFF 100%), url(` +
          illustration_full_path +
          `) !important`;
      } else
        trainingCssProps["background-image"] =
          `linear-gradient(180deg, rgba(255, 255, 255, 0) 61.46%, #FFFFFF 100%), url(` +
          illustration +
          `) !important`;

      return trainingCssProps;
    },
    getResource() {
      return JSON.parse(localStorage.getItem("settings")).resource_media.path;
    },
    ressourceUrl() {
      return (
        this.$http.defaults.baseURL.replace("/api/", "") + this.getResource()
      );
    },
  },
  mounted() {
    this.getPackInformation();
    this.getCategoriesTraining();
  },
};
</script>

<style lang="scss">
.pack__base {
  width: 100%;
  left: 0px;
  top: 0px;
}

.pack__splash_screen {
  width: 100%;
  height: 324px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, #ffffff 100%);
}

.pack__information {
  position: absolute;
  height: 100px;
  border-bottom: black;
  top: 100px;
  left: 25px;

  .pack__title {
    width: 100%;
    height: 48px;
    font-size: 40px;
    line-height: 56px;

    color: #ffffff;
  }
}

.pack__trainings {
  height: auto;
  border-bottom: black;

  p.fields_label {
    font-size: 11.5px;
  }

  .cardx {
    height: auto;
    background: #ffffff;
    box-shadow: 0px -17px 24px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
  }
}
.trainings {
  // max-width: 1200px;
  margin: 0 auto;
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr 1fr;
  // grid-template-rows: 1fr 1fr 1fr;
  gap: 32px 18px;
  // grid-template-areas:
  //   ". . ."
  //   ". . ."
  //   ". . .";

  .training {
    cursor: pointer;
    height: auto;

    .card {
      background-color: #fff;
      border-radius: 0.5rem 0.5rem 0px 0px;
      // box-shadow: 0.05rem 0.1rem 0.3rem -0.03rem rgba(0, 0, 0, 0.45);
      box-shadow: 0px -17px 24px rgba(0, 0, 0, 0.06);
      padding-bottom: 1rem;
    }

    .card > :last-child {
      margin-bottom: 0;
    }

    .card h3 {
      margin-top: 1rem;
      font-size: 1.25rem;
    }

    .training_illustration {
      border-radius: 0.5rem 0.5rem 0 0;
      width: 100%;
      height: 224.44px;
      background-repeat: no-repeat !important;
      background-size: 100% 100% !important;
    }

    .training_illustration ~ * {
      margin-left: 1rem;
      margin-right: 1rem;
    }
  }
}

.con-vs-chip {
  min-height: 20px;
  min-width: 26px;
  font-size: 0.8rem;
}

@media (min-width: 100px) {
  .trainings {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media (min-width: 600px) {
  .trainings {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 900px) {
  .trainings {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1400px) {
  .trainings {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>